import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { productSchema, ProductFormValues } from "@modules/defaultProducts/validations/productSchema";
import { useCreateProductMutation } from "@modules/defaultProducts/services/mutations";

export function useProductCreateForm() {
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useCreateProductMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"], refetchType: "all" });
      open?.({ type: "success", message: "Produto criado com sucesso" });
      navigate("/products");
    },
    onError: () => {
      open?.({ type: "error", message: "Erro ao criar produto" });
    },
  });

  const methods = useForm<ProductFormValues>({
    resolver: zodResolver(productSchema()),
    defaultValues: {
      name: "",
      is_bookstore: false,
      is_superapp: false,
      create_landing: false,
      active: true,
      metadata: {},
    },
    mode: "onBlur",
  });

  const { handleSubmit } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}


